<script setup lang="ts">
import {type BenefitWithLevel} from "#/BTNode";
import {computed, onMounted, onUpdated, ref} from "vue";
import {debug} from "@/store/bt";

const props = defineProps<{
  benefits: BenefitWithLevel[],
  index: number
}>()

const display = ref(false)
const benefit = ref()
// Template refs
const cell = ref<HTMLTableCellElement>()

const cellClass = computed(() => {
  if (benefit.value) {
    return benefit.value.value
  }
  return 'none'
})

function computeDisplay(): void {
  const table = cell.value?.closest('table') as HTMLTableElement
  const tr = table.querySelector('thead > tr:last-child') as HTMLTableRowElement
  const th = tr.cells[props.index];
  if (th) {
    benefit.value = props.benefits.find(ben => ben.benefitId == parseInt(th.getAttribute('data-id') as string))
    display.value = true
  }
}

onMounted(() => {
  computeDisplay()
})

onUpdated(() => {
  computeDisplay()
})
</script>

<template>
  <td :class="cellClass" ref="cell">
    <template v-if="benefit && debug">{{ index }} - {{ benefit.benefitId}} - {{ benefit.value }}</template>
  </td>
</template>

<style>
td {
  &.high {
    background-color: hsl(201.33deg 41.67% 57.65%);
  }
  &.medium {
    background-color: hsl(188.96deg 51.15% 74.31%);
  }
  &.low {
    background-color: hsl(189.23deg 52% 90.2%);
  }
  &.negative {
    background-color: hsl(331.17deg 72.64% 41.57%);
  }
  &.none {
    background-color: whitesmoke;
  }
}
</style>
